import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icons from "assets/icons";
import Icon from "@ant-design/icons";
import React from "react";

const {INPUT} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

export const FieldsSclera1: Array<DataFormField> = [
  {
    name: ["rightJsonValue", "SCLERA", "Comment"],
    label: "Ghi chú",
    type: INPUT,
    css: css,
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "SCLERA", "show"],
    hide: true,
  },
];

export const FieldsSclera2: Array<DataFormField> = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "SCLERA", "Comment"],
    css: css,
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "SCLERA", "show"],
    hide: true,
  },
];
